import { getLocalStorageService } from '@/core/container/ioc'

export const useLocalStorage = () => {
  const localStorage = getLocalStorageService()

  const get = <T>(key: string) => {
    const value = localStorage.get(key)

    if (value === null) {
      return undefined
    }

    return JSON.parse(value) as T
  }

  const set = (key: string, value: string | number | object) => {
    localStorage.set(key, JSON.stringify(value))
  }

  const remove = (key: string) => {
    localStorage.delete(key)
  }

  return {
    get,
    set,
    remove,
  }
}
